import React, { useEffect, useState } from 'react';
interface CountdownProps {
  initialHours?: number;
  initialMinutes?: number;
  initialSeconds?: number;
  className?: string;
  theme?: 'light' | 'dark' | 'danger' | 'premium';
}
export function Countdown({
  initialHours = 23,
  initialMinutes = 27,
  initialSeconds = 35,
  className = '',
  theme = 'danger'
}: CountdownProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const themes = {
    light: 'bg-white text-[#14301f] border-[#e0d6bf]',
    dark: 'bg-[#173325] text-[#f5efe1] border-[#2f6b47]',
    danger: 'bg-[#fbeee0] text-[#9c3f22] border-[#e0b48f]',
    premium: 'bg-[#c8971b]/15 text-[#a97e12] border-[#c8971b]/40'
  };
  return <div className={`inline-flex items-center gap-2 font-mono font-bold text-lg md:text-2xl px-4 py-2 rounded-lg border ${themes[theme]} ${className}`} data-id="element-326">
      <div className="flex flex-col items-center" data-id="element-327">
        <span data-id="element-328">{formatNumber(timeLeft.hours)}</span>
        <span className="text-[10px] uppercase tracking-wider opacity-70 font-sans" data-id="element-329">
          hs
        </span>
      </div>
      <span className="opacity-50 pb-4" data-id="element-330">:</span>
      <div className="flex flex-col items-center" data-id="element-331">
        <span data-id="element-332">{formatNumber(timeLeft.minutes)}</span>
        <span className="text-[10px] uppercase tracking-wider opacity-70 font-sans" data-id="element-333">
          min
        </span>
      </div>
      <span className="opacity-50 pb-4" data-id="element-334">:</span>
      <div className="flex flex-col items-center" data-id="element-335">
        <span data-id="element-336">{formatNumber(timeLeft.seconds)}</span>
        <span className="text-[10px] uppercase tracking-wider opacity-70 font-sans" data-id="element-337">
          seg
        </span>
      </div>
    </div>;
}